<template>
    <div>
        <a class="btn btn-default btn-sm" :title="title">
            <i :class="icon"></i>
        </a>
    </div>
</template>

<script>
    export default {
        
        props: {
            icon : {
                type: String,
                required : true
            },
            title: {
                type : String,
                required : true
            }
        }
    }
</script>